// 新建 src/utils/crypto.js

import CryptoJS from 'crypto-js/crypto-js'

const KEY = CryptoJS.enc.Utf8.parse('retedfgd')
const IV = CryptoJS.enc.Utf8.parse('asdqwe')
// AES加密 ：字符串 key iv  返回base64

/**
 * @description aes加密
 * @param str 需要加密的字符
 * @param keyStr 秘钥
 * @param ivStr 偏移
 */
export function Encrypt(str, keyStr, ivStr) {
    let key = KEY
    let iv = IV

    if (keyStr && ivStr) {
        key = CryptoJS.enc.Utf8.parse(keyStr)
        iv = CryptoJS.enc.Utf8.parse(ivStr)
    }
    key = CryptoJS.enc.Utf8.parse(keyStr)

    let srcs = CryptoJS.enc.Utf8.parse(str)
    var encrypted = CryptoJS.AES.encrypt(srcs, key, {
        // iv: iv,
        mode: CryptoJS.mode.ECB,
        // mode: CryptoJS.mode.ECB,  // mode 与后台一致
        padding: CryptoJS.pad.Pkcs7,
    })
    return CryptoJS.enc.Base64.stringify(encrypted.ciphertext)
}



// AES 解密 ：字符串 key iv  返回base64

export function Decrypt(str, keyStr, ivStr) {
    let key = KEY
    let iv = IV
    if (keyStr && ivStr) {
        key = CryptoJS.enc.Utf8.parse(keyStr)
        iv = CryptoJS.enc.Utf8.parse(ivStr)
    }
    let base64 = CryptoJS.enc.Utf8.parse(str)
    let src = CryptoJS.enc.Utf8.stringify(base64)
    key = CryptoJS.enc.Utf8.parse(keyStr)
    var decrypt = CryptoJS.AES.decrypt(src, key, {
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.Pkcs7
    })
    var decryptedStr = decrypt.toString(CryptoJS.enc.Utf8)
    return decryptedStr.toString()
}


// 生成uuid

export function uuid(len, radix) {
    var chars = '0123456789abcdefghijklmnopqrstuvwxyzabcdefghijklmnopqrstuvwxyz'.split('')
    var uuid = [],
        i
    radix = radix || chars.length

    if (len) {
        // Compact form
        for (i = 0; i < len; i++) uuid[i] = chars[0 | Math.random() * radix]
    } else {
        // rfc4122, version 4 form
        var r

        // rfc4122 requires these characters
        uuid[8] = uuid[13] = uuid[18] = uuid[23] = '-'
        uuid[14] = '4'

        // Fill in random data.  At i==19 set the high bits of clock sequence as
        // per rfc4122, sec. 4.1.5
        for (i = 0; i < 36; i++) {
            if (!uuid[i]) {
                r = 0 | Math.random() * 16
                uuid[i] = chars[(i == 19) ? (r & 0x3) | 0x8 : r]
            }
        }
    }

    return uuid.join('')
}
